define('main',[
  "jquery",
  "globals",
  "bootstrap",
  "content",
  "nav",
  "search",
  "comments",
  "annotations",
  "feedback",
  "review",
  "jquery-placeholder",
  "swipe-content",
  "toc-resize"
  
], function ($, globals) {
  "use strict";

  $("[placeholder]").filter(function () {
    return !$(this).parents("#login-popover").length;
  }).placeholder();

  $(document).ready(function () {
    if($("[data-lockcommenting]").attr("data-lockcommenting") === "true" && $("body[data-user-role]").attr("data-user-role") != "ADMINISTRATOR") {
      $("#comments #show-form").hide();
      setTimeout(function () {
        $("a[data-action=reply]").hide();
        $("a[data-action=edit]").hide();
        $("a[data-action=delete]").hide();
      }, 0);
    } else {
      $("#comments #show-form").show();
      setTimeout(function () {
        $("a[data-action=reply]").show();
        $("a[data-action=edit]").show();
        $("a[data-action=delete]").show();
      }, 0);
    }
  });
  
});

